<template>
  <v-layout wrap class="spectralis-color-buttons justify-center">
    <v-flex shrink>
      <v-btn text 
        class="modal-cta"
        :class="[{active: hasColorPalette}, colorClass]"
        @click="toggleColor">Color</v-btn>
      <v-btn text
        class="modal-cta"
        :class="[{active: isInverted}, colorClass]"
        @click="invertColor">Invert</v-btn>
      <v-btn text 
        v-if="sliceHasSegmentation"
        class="modal-cta"
        :class="[{active: showSegmentation}, colorClass]"
        @click="toggleSegmentation">Segmentation</v-btn>
      <v-btn text
        v-if="sliceHasSegmentation"
        class="modal-cta"
        :class="[{active: isMeasuring}, colorClass]"
        @click="measure">Measure</v-btn>
      <v-btn text
        v-if="showSpectralisThicknessMapButton"
        class="modal-cta"
        :class="[{active: showThicknessMap}, colorClass]"
        @click="toggleShowThicknessMap">Thickness Map</v-btn>
      <reset-slider
        v-if="showThicknessMap"
        :color="colorHex"
        :value="thicknessMapOpacity"
        :min="0"
        :max="1"
        :step="0.05"
        :defaultValue="0.5"
        @input="updateOpacity"
        name="Color Intensity"/>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import resetSlider from "../../controls/ResetSlider";

export default {
  name: "spectralisColorButtons",
  components: { resetSlider },
  computed: {
    ...mapGetters(["isInverted", "hasColorPalette", "showSegmentation", "isMeasuring", "sliceHasSegmentation", "showThicknessMap", "showSpectralisThicknessMapButton",
    "thicknessMapOpacity"])
  },
  methods: {
    toggleColor(){
      this.$store.dispatch("toggleColorPalette");
    },
    invertColor(){ 
      this.$store.dispatch("toggleInverted");
    },
    toggleSegmentation(){
      this.$store.commit("toggleSegmentation");
    },
    measure(){
      this.$store.commit("toggleMeasuring");
    },
    toggleShowThicknessMap(){
      this.$store.commit("toggleShowThicknessMap");
    },
    updateOpacity(opacity) {
      this.$store.commit("updateThicknessMapOpacity", opacity);
    },
  }
}
</script>